import React, { useState, useEffect } from 'react';
import { Button } from '@chapche/ui';
import { FilterIcon } from '../appearence/icons/filter_icon';
import OpenFilterButtonIcon from './OpenFilterButtonIcon';
import { filtersManager } from './filtering/filtersManager';
import { ItemsStorageService } from "./filtering/itemsStorageService";
import { useTranslation } from 'react-i18next';

interface OpenFilterButtonProps {
    itemsStorageService: ItemsStorageService,
}

const OpenFilterButton = ({ itemsStorageService }: OpenFilterButtonProps) => {
    const { i18n } = useTranslation();
    const [buttonIsActive, setButtonIsActive] = useState(false);

    const changeButtonState = (value: boolean) => {
        setButtonIsActive(value);
    };

    const handleButtonClick = () => {
        filtersManager.callToOpen(!buttonIsActive);
    };

    useEffect(() => {
        filtersManager.registerOpenStateObserver(changeButtonState);
        return () => filtersManager.unRegisterOpenStateObserver(changeButtonState);
    }, []);
    return (
        <Button
            variant={buttonIsActive ? 'default' : 'outline'}
            className="product__search-button relative ml-16"
            onClick={handleButtonClick}
        >
            <FilterIcon nameOfClass="product__search-icon mr-8 h-20 w-20" />
            {i18n.t("app.page.product.filter")}
            <OpenFilterButtonIcon itemsStorageService={itemsStorageService}/>
        </Button>
    );
};

export default OpenFilterButton;
